import { AnalyticsContext } from '@carvana/eventable-clickstream';
import cx from 'classnames';
import { useContext, memo, useCallback, useMemo } from 'react';
import { SPINNER_ENGAGED } from '~/constants/Events';
import Section, { SectionId } from '~/constants/vdp/section';
import SpinnerContext from '~/context/vdp/SpinnerContext';
import debounce from '~/utilities/debounce';
import { withErrorBoundary } from '~/utilities/ErrorBoundary';
import SpinnerLoader from './SpinnerLoaderMfe';

type OwnProps = {
  shouldHide?: boolean;
};

function Spinner({ shouldHide }: OwnProps) {
  const { trackEvent } = useContext(AnalyticsContext);
  const { spinnerReady, isSpinnerDisabled } = useContext(SpinnerContext);

  const debouncedTrackEvent = useMemo(
    () => debounce((event: string) => trackEvent(event), 300),
    [trackEvent]
  );

  const handleEngagement = useCallback(() => {
    debouncedTrackEvent(SPINNER_ENGAGED);
  }, [debouncedTrackEvent]);

  return (
    <div
      data-adobe-id="spinner-engaged"
      data-analytics-id={null}
      data-testid="spinner-container"
      className={cx({
        'is-error': spinnerReady.error,
        hidden: shouldHide
      })}
      id={SectionId.Spinner}
      onClick={handleEngagement}
      onTouchEnd={handleEngagement}
    >
      {!isSpinnerDisabled && <SpinnerLoader />}
    </div>
  );
}

export default withErrorBoundary(
  memo(Spinner),
  undefined,
  undefined,
  Section.Spinner
);
